<template>
	<div>
		<h1 style="margin-bottom: 10px; color: black">1 on 1 Chat Log</h1>
		<v-btn-toggle style="width: 100%; margin-bottom: 0px" mandatory>
			<v-btn @click="isBrowse = true" style="width: 50%">Browse</v-btn>
			<v-btn @click="isBrowse = false" style="width: 50%">Search</v-btn>
		</v-btn-toggle>
		<div v-if="isBrowse">
			<v-card>
				<v-card-text>
					<v-toolbar flat color="white" class="d-flex flex-row align-end justify-end" style="padding-top: 100px">
						<v-row>
							<v-col cols="12">
								<v-btn color="primary" dark class="mb-2 ml-5" @click="downloadCSV">
									<v-icon dark left>mdi-download</v-icon>CSV
								</v-btn>
							</v-col>
						</v-row>
					</v-toolbar>
				</v-card-text>
				<v-data-table :headers="headers" :items="bLogs" :search="search" item-key="id" class="elevation-1">
					<template v-slot:expanded-item="{ headers }">
						<td :colspan="headers.length" style="padding: 5px">
							<v-simple-table style="background-color: #f5f5f5"></v-simple-table>
						</td>
					</template>
				</v-data-table>
			</v-card>
		</div>
		<div v-else>
			<v-card>
				<v-card-text>
					<v-toolbar flat color="white" class="d-flex flex-row align-end justify-end" style="padding-top: 100px">
						<v-row>
							<v-col cols="2">
								<v-text-field v-model="searchKey" label="Key" single-line hide-details></v-text-field>
							</v-col>

							<v-col cols="2">
								<v-menu v-model="isShowStart" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
									<template v-slot:activator="{ on }">
										<v-text-field v-on="on" v-model="start" label="From Date" single-line readonly hide-details append-icon="mdi-calendar-today"></v-text-field>
									</template>
									<v-date-picker v-model="start" @input="isShowStart = false"></v-date-picker>
								</v-menu>
							</v-col>

							<v-col cols="2">
								<v-menu v-model="isShowEnd" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
									<template v-slot:activator="{ on }">
										<v-text-field v-on="on" v-model="end" label="To Date" single-line readonly hide-details append-icon="mdi-calendar-today"></v-text-field>
									</template>
									<v-date-picker v-model="end" @input="isShowEnd = false"></v-date-picker>
								</v-menu>
							</v-col>

							<v-col cols="2">
								<v-btn color="primary" dark class="mb-2" @click="getLog">FILTER</v-btn>
							</v-col>

							<v-col cols="2">
								<v-btn color="primary" dark class="mb-2 ml-5" @click="downloadCSV">
									<v-icon dark left>mdi-download</v-icon>CSV
								</v-btn>
							</v-col>
						</v-row>
					</v-toolbar>
				</v-card-text>
				<v-data-table :headers="headers" :items="sLogs" :search="search" item-key="id" class="elevation-1">
					<template v-slot:expanded-item="{ headers }">
						<td :colspan="headers.length" style="padding: 5px">
							<v-simple-table style="background-color: #f5f5f5"></v-simple-table>
						</td>
					</template>
				</v-data-table>
			</v-card>
		</div>
	</div>
</template>

<script>
import axios from "axios";
import configuration from "../../../../configuration";

const apiKey = configuration.apiKeyCometChat;
const appId = configuration.appIdCometChat;

export default {
	data() {
		return {
			search: "",
			bLogs: [],
			sLogs: [],
			headers: [
				{ text: "From", value: "from", sortable: false },
				{ text: "To", value: "to", sortable: false },
				{ text: "Message", value: "message", sortable: false },
				{ text: "Sent", value: "sent", sortable: false }
			],
			isBrowse: true,
			searchKey: null,
			start: null,
			end: null,
			epochStart: null,
			epochEnd: null,
			isShowStart: false,
			isShowEnd: false
		};
	},
	props: ["experienceId"],
	created: async function() {
		if (this.isBrowse) {
			await this.getLog();
		}
	},
	methods: {
		toHexString(text) {
			var result = "";
			for (var i = 0; i < text.length; i++) {
				result += text.charCodeAt(i).toString(16);
			}
			if (result.length > 100) {
				result = result.substring(0, 100);
			}
			return result;
		},

		getLog() {
			if (this.isBrowse) {
				this.searchKey = null;
				this.start = null;
				this.end = null;
				this.epochStart = null;
				this.epochEnd = null;
			} else {
				if (this.start != null && this.end != null) {
					var sDate = this.start.split("-")[2];
					var sMonth = this.start.split("-")[1];
					var sYear = this.start.split("-")[0];

					var eDate = this.end.split("-")[2];
					var eMonth = this.end.split("-")[1];

					var eYear = this.end.split("-")[0];

					this.epochStart = new Date(sYear, sMonth - 1, sDate, 0, 0, 0).getTime() / 1000;
					this.epochEnd = new Date(eYear, eMonth - 1, eDate, 23, 59, 59).getTime() / 1000;
				}
			}

			if (this.$store.state.isUseCometChat) {
				let type = "user";

				axios
					.post("/system/chat/log", {
						type: type,
						apiKey: apiKey,
						appId: appId,
						searchKey: this.searchKey != null ? encodeURI(this.searchKey) : this.searchKey,
						start: this.epochStart,
						end: this.epochEnd
					})
					.then(response => {
						if (this.isBrowse) {
							this.bLogs = [];
						} else {
							this.sLogs = [];
						}
						for (var i = 0; i < response.data.data.length; i++) {
							if (response.data.data[i].receiver.split("-")[0] == this.experienceId) {
								if (response.data.data[i].receiverType == "user") {
									if (this.isBrowse) {
										this.bLogs.push({
											id: response.data.data[i].id,
											from: response.data.data[i].data.entities.sender.entity.name,
											to: response.data.data[i].data.entities.receiver.entity.name,
											message: response.data.data[i].data.text,
											sent: new Date(response.data.data[i].sentAt * 1000)
										});
									} else {
										this.sLogs.push({
											id: response.data.data[i].id,
											from: response.data.data[i].data.entities.sender.entity.name,
											to: response.data.data[i].data.entities.receiver.entity.name,
											message: response.data.data[i].data.text,
											sent: new Date(response.data.data[i].sentAt * 1000)
										});
									}
								}
							}
						}
					})
					.catch(() => {});
			} else {
				axios
					.post("/system/vchat/log", {
						type: "private",
						searchKey: this.searchKey != null ? encodeURI(this.searchKey) : this.searchKey,
						start: this.start,
						end: this.end,
						experienceId: this.experienceId
					})
					.then(response => {
						if (response.data) {
							if (this.isBrowse) {
								this.bLogs = [];
							} else {
								this.sLogs = [];
							}
							for (let i = 0; i < response.data.length; i++) {
								if (this.isBrowse) {
									this.bLogs.push({
										id: response.data[i].message_id,
										from: response.data[i].sender.user_first_name + " " + response.data[i].sender.user_last_name,
										to: response.data[i].receiver.user_first_name + " " + response.data[i].receiver.user_last_name,
										message: response.data[i].message_content.replace(/<p>/g, "").replace(/<\/p>/g, ""),
										sent: response.data[i].message_created_at
									});
								} else {
									this.sLogs.push({
										id: response.data[i].message_id,
										from: response.data[i].sender.user_first_name + " " + response.data[i].sender.user_last_name,
										to: response.data[i].receiver.user_first_name + " " + response.data[i].receiver.user_last_name,
										message: response.data[i].message_content.replace(/<p>/g, "").replace(/<\/p>/g, ""),
										sent: response.data[i].message_created_at
									});
								}
							}
						}
						this.processing = false;
						this.isDownloadable = true;
					})
					.catch(() => {});
			}
		},
		downloadCSV() {
			let csv = "From,To,Message,Sent\n";

			if (this.isBrowse) {
				this.bLogs.forEach(row => {
					csv = csv + row.from + "," + row.to + "," + row.message + "," + row.sent + "\n";
				});
			} else {
				this.sLogs.forEach(row => {
					csv = csv + row.from + "," + row.to + "," + row.message + "," + row.sent + "\n";
				});
			}

			let anchor = document.createElement("a");
			anchor.href = "data:text/csv;charset=utf-8," + encodeURIComponent(csv);
			anchor.target = "_blank";
			anchor.download = "private-chat-log-result.csv";
			anchor.click();
		}
	}
};
</script>